import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useIsMobile } from '@sravni/react-utils';
import { MobileHeader, DesktopHeader } from '@sravni/react-header';
import { SberPromo } from '@sravni/react-shared-components/lib/SberPromo';
import { GlobalSearch } from '@sravni/react-search';
import getConfig from 'next/config';
import { IGlobalState } from '../../../store';
import { useUser } from '../../../store/reducers/user';

const Wrapper = styled.div`
    position: relative;
    z-index: 15;
`;

export const Header = () => {
    const user = useUser();
    const isMobile = useIsMobile();
    const settings = useSelector((state: IGlobalState) => state.siteSettings.header);
    const Component = isMobile ? MobileHeader : DesktopHeader;
    const { asPath } = useRouter();
    const currentLocation = useSelector((state: IGlobalState) => state.locations.currentLocation);
    const searchUrl = getConfig().publicRuntimeConfig.publicUrl;

    return (
        <Wrapper>
            <Component
                settings={settings}
                user={user || undefined}
                promo={<SberPromo />}
                enableTheme
                currentRegion={currentLocation}
                search={<GlobalSearch searchServiceHost={searchUrl} asPath={asPath} />}
            />
        </Wrapper>
    );
};
